import React from 'react';
import './EditorCard.less';
import OkCancel from '../../Buttons/OkCancel';
import type {VoidCallback} from "../../../@types/functions";

/**
 * This is a simple editor card class that can be used when there is nothing to edit, just a card to show with
 * a close box.
 */
function EditorCard(props: EditorCardProps) {
	return (
		<div className='editor-card'>

			{/* Ok/Cancel button */}
			<OkCancel label={props.label}
					  disabled={false}
					  onTop={true}
					  onCancel={props.onCancel}
			/>

			{/* Content */}
			{props.renderFn(props.current)}
		</div>
	);
}

export type EditorCardProps = {
	// Type of thing to view
	label: string,

	// The object to be manipulated
	current: any,

	// Props to pass along to the editor
	editorProps?: any,

	// ID to use for a new instance
	newId?: string,

	// Function to call when all editing is finished
	onOk?: Function,

	// Function to call if we decide not to save changes
	onCancel?: VoidCallback,

	// Callback to render the item
	renderFn: (item: any) => React.ReactNode,
};

export default EditorCard;
